import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, switchMap } from 'rxjs/operators';
import { AutoCompleteComponent } from '@components/dynamic-form/auto-complete/auto-complete.component';
import { AutocompleteControl } from '@components/dynamic-form/auto-complete/autocomplete-control';
import { TestDriveService } from '@services/test-drive.service';
import { VehicleSearchModel } from '@/models/test-drive/vehicle-search.model';
import { LoggerService } from '@services/logger.service';
import { Registry } from '@/registry.service';

@Component({
  selector: 'app-auto-complete-vehicle',
  templateUrl: '../../auto-complete.component.html',
  styleUrls: ['../../auto-complete.component.scss'],
})
export class AutoCompleteVehicleComponent extends AutoCompleteComponent implements OnInit {
  @Input() meta!: AutocompleteControl;
  @Input() form!: FormGroup;
  @Input() indexRow: number = null;
  @Input() keyformArrayName: any;
  control = new FormControl('');
  filteredOptions: Observable<VehicleSearchModel[]>;

  constructor(private testDriveService: TestDriveService) {
    super();
  }

  ngOnInit(): void {
    this.setControl();

    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((value) => {
        // Se il valore è un oggetto (selezione), non fare chiamata API
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          return of([]);
        }
        // Se è una stringa, estrai il termine di ricerca
        const searchTerm = typeof value === 'string' ? value : this.getValue(value);
        if (!searchTerm || searchTerm.length < 4) {
          return of([]);
        }
        return this.testDriveService.searchVehicle(searchTerm);
      }),
    );
  }

  displayFn(selectedOption: any): string {
    if (!selectedOption) {
      return '';
    }
    if (typeof selectedOption === 'string') {
      return selectedOption;
    }
    const vehicle = selectedOption as VehicleSearchModel;
    const numeroPratica = vehicle.codicePratica || '';
    const marcaDesc = vehicle.marca?.descrizioneMarca || vehicle.marca || '';
    const modello = vehicle.descrizioneModello || 'Modello assente';
    const targa = vehicle.targa || 'Targa assente';
    const telaio = vehicle.telaio || 'Telaio assente';
    return (
      vehicle.descrizione || `${numeroPratica} - ${targa} - ${telaio} - ${marcaDesc} - ${modello}`
    );
  }

  protected getValue(obj: any): string {
    if (!obj) {
      return '';
    }
    if (typeof obj === 'string') {
      return obj;
    }
    const vehicle = obj as VehicleSearchModel;
    const numeroPratica = vehicle.codicePratica || '';
    const marcaDesc = vehicle.marca?.descrizioneMarca || vehicle.marca || '';
    const modello = vehicle.descrizioneModello || 'Modello assente';
    const targa = vehicle.targa || 'Targa assente';
    const telaio = vehicle.telaio || 'Telaio assente';
    return (
      vehicle.descrizione || `${numeroPratica} - ${targa} - ${telaio} - ${marcaDesc} - ${modello}`
    );
  }

  protected customActionInput(event, indexRow = null) {
    LoggerService.log('Vehicle Selected!');

    if (
      this.meta.classToUse &&
      this.meta.customAction &&
      Registry.getInstance().get(this.meta.classToUse) &&
      Registry.getInstance().get(this.meta.classToUse)[this.meta.customAction]
    ) {
      Registry.getInstance()
        .get(this.meta.classToUse)
        [this.meta.customAction](event.option.value, indexRow);
    } else {
      LoggerService.log('Vehicle selection function not found');
    }
  }
}
